import { Alert } from "@mui/material";
import * as React from "react";
import InfoBannerSvg from "./InfoBannerSvg";
import { useTranslation } from "react-i18next";

export const InfoBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="infoBanner">
      <Alert
        icon={<div>{InfoBannerSvg()}</div>}
        sx={{
          background: "white",
          color: "black",
          marginTop: "10px",
          marginBottom: "15px",
          padding: "0px 0px",
        }}
      >
        <div>
         {t("Helpline")}{" "}
          <a href="tel:415-973-4548" style={{ color: "#07679B" }}>
            (415) 973-4548
          </a>{" "}
          {t("ForAssistance.")}
        </div>
      </Alert>
    </div>
  );
};
